import { useContext } from 'react';

import { CustomReportBuilderContext } from '../report-builder/custom-report-builder-provider';

export enum ReportBuilderFlowType {
  MiddlewareReports = 'middlewareReports',
  CustomReports = 'customReports',
}

export const useInReportBuilderFlowType = () => {
  const { selectedReportTemplate } = useContext(CustomReportBuilderContext);

  return selectedReportTemplate
    ? ReportBuilderFlowType.CustomReports
    : ReportBuilderFlowType.MiddlewareReports;
};
